import { render } from "./one-more-question-current.vue?vue&type=template&id=e972b8dc"
import script from "./one-more-question-current.vue?vue&type=script&lang=js"
export * from "./one-more-question-current.vue?vue&type=script&lang=js"

import "./one-more-question-current.vue?vue&type=style&index=0&id=e972b8dc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__